/*eslint-disable*/
export default [
    {
        path: '',
        name: 'login',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */'../../components/auth/Login.vue'),
        meta: {
            title: 'Вход'
        }
    },
    {
        path: 'forgot',
        name: 'forgot',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */'../../components/auth/ForgotPassword.vue'),
        meta: {
            title: 'Восстановление пароля'
        }
    },
    {
        path: 'reset/:token',
        name: 'reset',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */'../../components/auth/ResetPassword.vue'),
        meta: {
            title: 'Восстановление пароля'
        }
    },
    {
        path: 'registration',
        name: 'registration',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */'../../components/auth/Registration.vue'),
        meta: {
            title: 'Регистрация'
        }
    }
];